module.exports = __webpack_public_path__ + "static/media/practitioner.d3b51c2a.svg";